import React from 'react';
import styled from 'styled-components';

interface StarProps {
  value: number;
  readonly: boolean;
  onClick: () => void;
  onMouseEnter: () => void;
}

const Star: React.FC<StarProps> = ({
  value = 1,
  readonly = true,
  onClick,
  onMouseEnter,
}) => {
  return (
    <StarContainer
      className={`star-${value === 1 ? 'light' : 'default'} ${
        readonly ? 'readonly' : ''
      }`}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
    >
      {value > 0 && value < 1 && (
        <span
          className="light-percent"
          style={{ width: `${value * 100}%` }}
        ></span>
      )}
    </StarContainer>
  );
};

const StarContainer = styled.div`
  position: relative;
  display: inline-block;
  margin: 0 1px;
  cursor: pointer;
  &.star-light {
    display: inline-block;
    background: url(${require('./images/star-light.png')}) no-repeat 0 0 /
      contain;
    width: 11px;
    height: 10px;
  }
  &.star-default {
    display: inline-block;
    background: url(${require('./images/star-default.png')}) no-repeat 0 0 /
      contain;
    width: 11px;
    height: 10px;
    .light-percent {
      position: absolute;
      top: 0;
      left: 0;
      display: inline-block;
      height: 100%;
      background: url(${require('./images/star-light.png')}) no-repeat 0 0 /
        cover;
    }
  }
  ._dark &.star-default {
    background-image: url(${require('./images/star-default-grey.png')});
  }
  &.readonly {
    cursor: default;
  }
`;

export default Star;
